if (window.location.hash && window.location.hash.startsWith("#c")) {
    import("./modules/scrollTo.mjs").then((m) => m.init());
}

if (document.querySelector("[data-ccm-loader-group]")) {
    import("./modules/ccm19.mjs").then((m) => m.init());
}
